export enum EstadoNotificacion {
  saldoExcedido = 0,
  saldoVencido = 1,
  previoAlExcedido = 2
}
